import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RefreshDataDto } from 'src/app/interfaces/Dtos/refresh-data.dto';

@Injectable({
  providedIn: 'root'
})
export class ControlTowerModalService {

  private refreshGridSubject = new Subject<RefreshDataDto>()
  refreshGridObservable = this.refreshGridSubject.asObservable()

  refresh(refreshData:RefreshDataDto) {
    this.refreshGridSubject.next(refreshData)
  }
}
